import { generateAutomationName } from "../../helpers/generateAutomationName";

export const gaWidgetDataAutomation = {
    draggableWidget: generateAutomationName("GAwidget", ["carousel", "list", "draggable", "widget"]),

    connectFirstPartyDataButton: generateAutomationName("GAwidget", ["connect", "first", "party", "data", "button"]),

    activateGAButton: generateAutomationName("GAwidget", ["activate", "GA", "button"]),
    connectGAButton: generateAutomationName("GAwidget", ["connect", "GA", "button"]),

    connectionDataBadge: generateAutomationName("GAwidget", ["connection", "first", "data", "badge"]),
    connectionDataText: generateAutomationName("GAwidget", ["connection", "first", "data", "text"]),

    carouselListWidgets: generateAutomationName("GAwidget", ["carousel", "list", "widgets"]),

    widgetItem: generateAutomationName("GAwidget", ["widget", "item"]),

    gaMappingInfoBannerPrefix: generateAutomationName("project", ["ga", "info-banner"]),
};

export const activationModalDataAutomation = {
    header: generateAutomationName("activationModal", ["header"]),

    getOptionContainer: (title: string) => generateAutomationName("activationOption", ["container", title]),

    getIconContainer: (iconName: string) => generateAutomationName("activationOption", ["icon", "container", iconName]),

    modalContainer: generateAutomationName("activationModal", ["container"]),
};
